import { i18n, Locale } from '@lingui/core';
import { messages as enMessages } from '../../locale/en/messages';
import { messages as fiMessages } from '../../locale/fi/messages';
import { messages as nbMessages } from '../../locale/nb/messages';

export const loadI18nStatic = () => {
    i18n.load({ en: enMessages, fi: fiMessages, nb: nbMessages });
};

export const activateI18n = (locale: Locale) => {
    i18n.activate(locale);
};

export const loadAndActivateI18n = (locale: Locale) => {
    i18n.load({ en: enMessages, fi: fiMessages, nb: nbMessages });
    i18n.activate(locale);
};
